<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        <h5 class="font-semibold m-0"><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>
          Engagement Record</h5>
      </template>
      <a-form :layout="'horizontal'">

        <!-- <pre>{{ formData }}</pre> -->
        <!-- <pre>{{ formDefaultData }}</pre> -->

        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Activity Name <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="12">
            <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
              v-model="formData.activity_name">
              <a-select-option v-for="(item, index) in optionAc" :key="index" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>

        <!-- <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Donation/Fee <span class="text-danger"></span>
            </p>
          </a-col>
          <a-col :span="10">
            <a-radio-group v-model="formData.donation_fee">
              <a-radio-button :value="true">Yes</a-radio-button>
              <a-radio-button :value="false">No</a-radio-button>
            </a-radio-group>
          </a-col>
        </a-row> -->

        <!-- <a-card style="box-shadow: none" v-if="formData.donation_fee"> -->
        <a-card style="box-shadow: none">
          <a-row class="mt-10 mb-10">
            <a-col :span="6">
              <p class="text-center mt-5 mb-0 font-bold">
                <b>Donation/Fee</b>
              </p>
            </a-col>
          </a-row>
          <a-row class="mt-20 mb-10">
            <a-col :span="6">
              <p class="text-center mt-5 mb-0 font-bold">
                Set Default Data <span class="text-danger"></span>
              </p>
            </a-col>
            <a-col :span="12">
              <a-radio-group v-model="formData.set_default_data">
                <a-radio-button :value="true">Yes</a-radio-button>
                <a-radio-button :value="false">No</a-radio-button>
              </a-radio-group>
            </a-col>
            <a-col :span="3" class="ml-10 text-left">
              <!-- <a-button type="primary" @click="getDataStd" :loading="!isAddPratBtnLoaded"
                :disabled="!formData.set_default_data"> -->
                <a-button type="primary" @click="getDataStd" :loading="!isAddPratBtnLoaded"
              >
                <span v-if="isAddPratBtnLoaded"> Update Data </span>
                <span v-else> Loading.. </span>
              </a-button>
            </a-col>
          </a-row>

          <!-- 
              <a-row class="mt-20 mb-10">
                <a-col :span="6">
                </a-col>
                <a-col :span="12">
                  <a-radio-group v-model="formDefaultData.donation_fee_type" :disabled="!formData.set_default_data">
                    <a-radio-button value="fee">Fee</a-radio-button>
                    <a-radio-button value="sponsorship">Sponsorship</a-radio-button>
                    <a-radio-button value="charity">Charity</a-radio-button>
                  </a-radio-group>
                </a-col>
              </a-row>
          -->


          <a-row class="mt-10 mb-10">
            <a-col :span="6">
              <p :style="!formData.set_default_data ? 'color:grey' : ''" class="text-center mt-5 mb-0 font-bold">
                Fee
              </p>
            </a-col>
            <a-col :span="12">
              <a-input type="number" v-model="formDefaultData.donation_fee" placeholder=""
                :disabled="!formData.set_default_data" />
            </a-col>
          </a-row>
          <a-row class="mt-10 mb-10">
            <a-col :span="6">
              <p :style="!formData.set_default_data ? 'color:grey' : ''" class="text-center mt-5 mb-0 font-bold">
                Sponsorship
              </p>
            </a-col>
            <a-col :span="12">
              <a-input type="number" v-model="formDefaultData.donation_sponsorship" placeholder=""
                :disabled="!formData.set_default_data" />
            </a-col>
          </a-row>
          <a-row class="mt-10 mb-10">
            <a-col :span="6">
              <p :style="!formData.set_default_data ? 'color:grey' : ''" class="text-center mt-5 mb-0 font-bold">
                Charity
              </p>
            </a-col>
            <a-col :span="12">
              <a-input type="number" v-model="formDefaultData.donation_charity" placeholder=""
                :disabled="!formData.set_default_data" />
            </a-col>
          </a-row>

          <a-row class="mt-10 mb-10">
            <a-col :span="6">
              <p :style="!formData.set_default_data ? 'color:grey' : ''" class="text-center mt-5 mb-0 font-bold">
                Item (s)
              </p>
            </a-col>
            <a-col :span="12">
              <a-button type="dashed" block @click="addItem" :disabled="!formData.set_default_data">
                <!-- <PlusOutlined /> -->
                + Add Item
              </a-button>
            </a-col>
          </a-row>

          <span v-for="(item, index) in formDefaultData.items" :key="'a' + index">
            <a-row class="mt-10 mb-0">
              <a-col :span="6"> </a-col>
              <a-col :span="6">
                <a-input v-model="item.item_detail" placeholder="name" />
              </a-col>
              <a-col :span="4" offset="1">
                <a-input v-model="item.amount" placeholder="amount" />
                <!-- <MinusCircleOutlined /> -->
              </a-col>
              <a-col :span="2">
                <a-button type="link" class="text-center" @click="removeItem(item)">
                  <a-icon style="font-size: 20px; color: red" type="delete" />
                </a-button>
              </a-col>
            </a-row>
          </span>

          <a-row class="mt-20 mb-10">
            <a-col :span="6">
              <!-- <p :style="!formData.set_default_data ? 'color:grey' : ''" class="text-center mt-5 mb-0 font-bold"> -->
              <p class="text-center mt-5 mb-0 font-bold">
                Role and Duty in the Activity
              </p>
            </a-col>
            <a-col :span="12">
              <!-- <a-select show-search placeholder="select reason type ..." option-filter-prop="children"
                v-model="formDefaultData.role_and_duty" :disabled="!formData.set_default_data"> -->
              <a-select show-search placeholder="select reason type ..." option-filter-prop="children"
                v-model="formDefaultData.role_and_duty">
                <a-select-option v-for="(item, index) in optionRoleAndDuty" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>

          <!-- <pre>{{ formDefaultData }}</pre> -->

          <a-row v-if="formDefaultData.role_and_duty === 8" class="mt-10 mb-10">
            <a-col :span="6"> </a-col>
            <a-col :span="12">
              <a-form-item label="" extra="Please Specify other Role and Duty " :disabled="!formData.set_default_data">
                <a-input v-model="formDefaultData.other_role" placeholder="" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>

        <!-- 
          <a-row class="mt-0 mb-0">
            <a-col :span="6">
              <p class="text-center mt-5 mb-0 font-bold">
                Donation/Fee <span class="text-danger">*</span>
              </p>
            </a-col>
            <a-col :span="12">
              <a-form-item label="" extra="">
                <a-input v-model="valA" placeholder="" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row class="mt-0 mb-0">
            <a-col :span="6">
              <p class="text-center mt-5 mb-0 font-bold">
                Donation/Sponsorship <span class="text-danger">*</span>
              </p>
            </a-col>
            <a-col :span="12">
              <a-form-item label="" extra="">
                <a-input v-model="valB" placeholder="" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row class="mt-0 mb-0">
            <a-col :span="6">
              <p class="text-center mt-5 mb-0 font-bold">
                Donation/Charity <span class="text-danger">*</span>
              </p>
            </a-col>
            <a-col :span="12">
              <a-form-item label="" extra="">
                <a-input v-model="valC" placeholder="" />
              </a-form-item>
            </a-col>
          </a-row> 
        -->

        <a-row class="mt-20 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Participants <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="10">
            <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="textParticipants" />
          </a-col>
          <a-col :span="3" class="ml-10 text-left">
            <a-button type="primary" @click="getDataStd" :loading="!isAddPratBtnLoaded">
              <span v-if="isAddPratBtnLoaded">
                <a-icon type="plus-circle" theme="outlined" />Add
              </span>
              <span v-else> Loading.. </span>
            </a-button>
          </a-col>
        </a-row>

        <a-row class="mt-20 mb-10">
          <a-col :span="10">
            <div>
              <a-tag color="green">
                <p class="text-center mt-5 mb-0 font-bold">
                  Participants <span class="text-danger">{{ tableData.length }}</span> person
                </p>
              </a-tag>
            </div>
          </a-col>
        </a-row>

        <!-- list data -->
        <a-row class="mt-20">
          <!-- <a-col :span="6"></a-col> -->
          <a-col :span="24">
            <!-- <pre>{{ tableData }}</pre> -->
            <a-table size="small" :columns="tableColumns" :data-source="tableData" :pagination="true"
              :loading="!isAddPratBtnLoaded" bordered>
              <template slot="donation_fee" slot-scope="text, record">
                <div>
                  <a-input type="number" v-model:value="record.donation_fee" placeholder="" />
                </div>
              </template>
              <template slot="donation_sponsorship" slot-scope="text, record">
                <div>
                  <a-input type="number" v-model:value="record.donation_sponsorship" placeholder="" />
                </div>
              </template>

              <template slot="donation_charity" slot-scope="text, record">
                <div>
                  <a-input type="number" v-model:value="record.donation_charity" placeholder="" />
                </div>
              </template>
              <template slot="role_and_duty" slot-scope="text, record">
                <div>
                  <a-select show-search placeholder="select reason type ..." option-filter-prop="children"
                    v-model="record.role_and_duty">
                    <a-select-option v-for="(item, index) in optionRoleAndDuty" :key="index" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </div>
              </template>

              <template slot="other_role" slot-scope="text, record">
                <div>
                  <a-input v-model:value="record.other_role" placeholder="" :disabled="record.role_and_duty !== 8" />
                </div>
              </template>

              <template slot="items" slot-scope="column, record, index">
                <p>
                  <!-- {{ record.alumni_id }} -->
                  <!-- <pre>{{ record.alumni_id }}.{{ record.items }}</pre> -->
                  <span v-for="(item, index) in record.items" :key="index" :value="item.value">
                    {{ item.item_detail + " " + item.amount }}
                    {{ index != record.items.length - 1 ? "," : "" }}
                  </span>
                  <a-button type="primary" @click="editItems(record.alumni_id, record)">
                    Edit
                  </a-button>
                </p>
              </template>

              <template slot="delete_action" slot-scope="text, record">
                <a-popconfirm title="Are you sure to Delete？" @confirm="removeParticipant(record.id)">
                  <a-icon slot="icon" type="question-circle-o" style="color: red" />
                  <a-button type="danger" icon="delete"></a-button>
                </a-popconfirm>
              </template>
            </a-table>
          </a-col>
        </a-row>

        <a-form-item class="mt-20" :wrapper-col="{ span: 12, offset: 6 }">
          <!--  onSubmitEngament -->
          <a-button :disabled="formData.activity_name == '' || tableData.length == 0" type="primary" class="mr-10"
            @click="visible = !visible">
            Submit
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>
      </a-form>

      <!-- <p>{{ indexSelected }}</p> -->
      <!-- <pre>{{ tableData }}</pre> -->

    </a-card>

    <!-- modal -->
    <a-modal v-model="visible" title="Confirm ?" on-ok="handleOk" :closable="false" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="visible = !visible"> Return </a-button>
        <a-button key="submit" type="primary" :loading="!btnLoaded" @click="onSubmitEngament">
          <span v-if="btnLoaded">
            Submit
          </span>
          <span v-else> Loading.. </span>
        </a-button>
      </template>
      <p class="mt-0 mb-0">Do you want to add these items ?</p>
    </a-modal>
    <!-- modal -->

    <!-- modal item edit -->
    <a-modal :width="500" v-model="visibleEditItem" title="Edit Items">
      <template slot="footer">
        <a-button key="back" @click="clearModalEdit"> Close pop-up </a-button>
      </template>
      <div v-if="Object.keys(selectedEditItems).length != 0">
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">Item (s)</p>
          </a-col>
          <a-col :span="12">
            <a-button type="dashed" block @click="addItemEdit(selectedEditItems.alumni_id)">
              + Add Item
            </a-button>
          </a-col>
        </a-row>
        <span v-for="(listItem, index) in formEditRowItem" :key="'b' + index">
          <a-row class="mt-10 mb-0">
            <a-col :span="6"> </a-col>
            <a-col :span="6">
              <a-input v-model="listItem.item_detail" placeholder="name"
                @change="updateValInput(selectedEditItems.alumni_id, index)" />
            </a-col>
            <a-col :span="4" offset="1">
              <a-input type="number" v-model="listItem.amount" placeholder="amount"
                @change="updateValInput(selectedEditItems.alumni_id, index)" />
            </a-col>
            <a-col :span="2">
              <a-button type="link" class="text-center" @click="removeItemByRow(selectedEditItems.alumni_id, index)">
                <a-icon style="font-size: 20px; color: red" type="delete" />
              </a-button>
            </a-col>
          </a-row>
        </span>
      </div>

    </a-modal>
    <!-- modal item edit -->

  </div>
</template>

<script>
import ReportTable from "./ReportTable";

const form = {
  activity_name: "",
  donation_fee: false,
  set_default_data: false,
};

const formDefault = {
  donation_fee_type: "fee",
  donation_fee: 0,
  donation_sponsorship: 0,
  donation_charity: 0,
  role_and_duty: "",
  other_role: "",
  items: [],
};

const formEditRowItem = {
  name: '',
  amount: '',
}

const tableColumns = [
  {
    title: "Student ID",
    dataIndex: "stu_id",
    scopedSlots: { customRender: "stu_id" },
    sorter: true,
    width: 80,
  },
  {
    title: "Name",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
    width: 200,
  },
  {
    title: "Fee",
    dataIndex: "donation_fee",
    scopedSlots: { customRender: "donation_fee" },
    width: 60,
  },
  {
    title: "Sponsorship",
    dataIndex: "donation_sponsorship",
    scopedSlots: { customRender: "donation_sponsorship" },
    width: 60,
  },
  {
    title: "Charity",
    dataIndex: "donation_charity",
    scopedSlots: { customRender: "donation_charity" },
    width: 60,
  },
  {
    title: "Role and Duty",
    dataIndex: "role_and_duty",
    scopedSlots: { customRender: "role_and_duty" },
    width: 100,
  },
  {
    title: "Other Role and Duty",
    dataIndex: "other_role",
    scopedSlots: { customRender: "other_role" },
    width: 100,
  },
  {
    title: "Items",
    dataIndex: "items",
    scopedSlots: { customRender: "items" },
    width: 150,
  },
  {
    title: "",
    scopedSlots: { customRender: "delete_action" },
    width: 20,
  },
];

export default {
  components: {
    ReportTable,
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(form)),
      formDefaultData: JSON.parse(JSON.stringify(formDefault)),
      optionAc: [],
      optionRoleAndDuty: [],
      // table
      tableColumns,
      tableData: [],
      textParticipants: "",
      // modal
      visible: false,
      btnLoaded: true,
      isAddPratBtnLoaded: true,
      formEditRowItem: [],
      //
      visibleEditItem: false,
      selectedEditItems: [],
      indexSelected: "",
      valA: 0,
      valB: 0,
      valC: 0,
    };
  },
  computed: {},
  watch: {
    "formData.role_and_duty"(val) {
      this.formData.other_role = "";
    },
    // "formData.set_default_data"(val) {
    //   if (!val) {
    //     this.formDefaultData = {
    //       donation_fee_type: "fee",
    //       cash: "",
    //       role_and_duty: "",
    //       other_role: "",
    //       items: [],
    //     };
    //   }
    // },
  },
  mounted() {
    this.getActivity();
    this.getRoleAndDutyList();
  },
  methods: {
    goToMainPage() {
      if (this.$route.query.profile_id_callback) {//redirect alumni profile
        this.$router
          .push({
            path: "/alumni/formprofile?id=" + this.$route.query.profile_id_callback,
          })
          .catch((err) => { });
      } else {//redirect enagement record 
        this.$router
          .push({
            path: "/engagement",
          })
          .catch((err) => { });
      }
    },
    // option form
    async getActivity() {
      this.optionAc = [];
      try {
        const res = await this.$http.get(`/student_affair/alumni-activity/`);
        if (res.status === 200) {
          this.optionAc = res.data.map((item) => {
            return {
              value: item.id,
              text: `${item.name_of_activity}`,
            };
          });
        }
      } catch (error) { }
    },
    async getRoleAndDutyList() {
      this.optionRoleAndDuty = [];
      try {
        const res = await this.$http.get(
          `/student_affair/role-and-duty-in-the-activity/`
        );
        if (res.status === 200) {
          this.optionRoleAndDuty = res.data.map((item) => {
            return {
              value: item.id,
              text: `${item.name_eng}`,
            };
          });
        }
      } catch (error) { }
    },
    // end form
    clearForm() {
      this.formData = Object.assign({}, form);
      this.$router
        .push({
          path: "/engagement/",
        })
        .catch((err) => { });
    },
    // edit table
    editItems(index, data) {
      this.formEditRowItem = []
      this.indexSelected = index;
      this.selectedEditItems = data;
      for (let index = 0; index < data.items.length; index++) {
        const elementIn = data.items[index];
        this.formEditRowItem.push(
          {
            'item_detail': elementIn.item_detail,
            'amount': elementIn.amount,
          }
        )
      }
      // //console.log(index,this.selectedEditItems)
      this.visibleEditItem = true;
    },
    updateValInput(id, indexForm) {
      const indexRow = this.tableData.findIndex(
        (list) => list.alumni_id == id
      );
      // //console.log(this.formEditRowItem[indexForm])
      let items = this.formEditRowItem
      this.tableData[indexRow] = {
        ...this.tableData[indexRow],
        items
      }
      let arrUpInput = [];
      arrUpInput.push(this.tableData[indexRow]);
      this.tableData.splice(
        indexRow,
        1,
        arrUpInput[0]
      );
    },
    addItemEdit() {
      this.formEditRowItem.push(
        {
          'item_detail': '',
          'amount': 0,
        }
      )
    },
    removeParticipant(idDel) {
      //console.log(idDel)
      const indexDel = this.tableData.findIndex(
        (itemDel) => itemDel.id === idDel
      );
      this.tableData.splice(indexDel, 1);
    },
    removeItemByRow(id, indexForm) {
      //console.log(indexForm);
      if (indexForm !== -1) {
        this.formEditRowItem.splice(indexForm, 1);
      }
      // update
      const indexRowDel = this.tableData.findIndex(
        (list) => list.alumni_id == id
      );
      let items = this.formEditRowItem
      this.tableData[indexRowDel] = {
        ...this.tableData[indexRowDel],
        items
      }
      let arrUpBeforeDel = [];
      arrUpBeforeDel.push(this.tableData[indexRowDel]);
      this.tableData.splice(
        indexRowDel,
        1,
        arrUpBeforeDel[0]
      );
    },
    // modal edit
    clearModalEdit() {
      this.visibleEditItem = false
      this.indexSelected = ''
    },
    // add / remove input default
    addItem() {
      this.formDefaultData.items.push({
        item_detail: "",
        amount: 0,
      });
    },
    removeItem(item) {
      let index = this.formDefaultData.items.indexOf(item);
      if (index !== -1) {
        this.formDefaultData.items.splice(index, 1);
      }
    },
    // call stdlist
    async getDataStd() {

      this.tableData = [];

      this.isAddPratBtnLoaded = false;

      let arrDefault = this.formDefaultData.items

      //Mockup Data//

      try {
        const sendData = new FormData();
        sendData.append("user_code", this.textParticipants);
        const response = await this.$http.post(
          "/student_affair/alumni-profile/pre_add_alumni_member/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          // //console.log(response.data)
          this.tableData = response.data.map((item) => {
            return {
              alumni_id: item.alumni_id,
              stu_id: item.student_id,
              name: `${item.name}`,
              donation_fee: this.formData.set_default_data ? this.formDefaultData.donation_fee : this.valA,
              donation_sponsorship: this.formData.set_default_data ? this.formDefaultData.donation_sponsorship : this.valB,
              donation_charity: this.formData.set_default_data ? this.formDefaultData.donation_charity : this.valC,
              role_and_duty:  this.formDefaultData.role_and_duty,//this.formData.set_default_data ? this.formDefaultData.role_and_duty : '',
              other_role: this.formData.set_default_data ? this.formDefaultData.other_role : '',
              items: this.formData.set_default_data ? [].concat(arrDefault) : [],
            };
          });
          this.isAddPratBtnLoaded = true;

        } else {
          throw { response };
        }
      } catch (error) {
        // //console.log(error)
        this.isAddPratBtnLoaded = true;
      }

    },
    async onSubmitEngament() {
      this.btnLoaded = false;
      for (let std = 0; std < this.tableData.length; std++) {

        // --> set json main
        var jsonActivity = {}
        jsonActivity['engement_activity'] = this.formData.activity_name;
        const dataList = this.tableData[std];
        const keys = Object.keys(dataList);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (key === 'alumni_id') {
            jsonActivity['alumni_profile'] = dataList[key];
          }
          if (key === 'donation_fee') {
            jsonActivity['amount_fee'] = dataList[key];
          }
          if (key === 'donation_sponsorship') {
            jsonActivity['amount_sponsorship'] = dataList[key];
          }
          if (key === 'donation_charity') {
            jsonActivity['amount_charity'] = dataList[key];
          }
          if (key === 'role_and_duty') {
            jsonActivity['role_and_duty_in_the_activity'] = dataList[key];
          }
          if (key === 'other_role') {
            jsonActivity['role_and_duty_in_the_activity_other'] = dataList[key];
          }
        }

        // ---> add item
        const responsesItem = [];
        for (let i = 0; i < dataList.items.length; i++) {
          const elementItem = dataList.items[i];
          // //console.log(elementItem);
          responsesItem.push(
            await this.$http.post("/student_affair/donation-item/", elementItem)
          );
        }
        jsonActivity['item'] = []
        for (let r = 0; r < responsesItem.length; r++) {
          const elementRes = responsesItem[r];
          jsonActivity['item'].push(elementRes.data.id)
        }

        // ---> add main activity
        //console.log(jsonActivity)
        try {
          const resA = await this.$http.post(
            "/student_affair/engagement-record/",
            jsonActivity
          );
          if (resA.status === 201) {
            jsonActivity = {}
          }
        } catch (error) { }
      }

      this.btnLoaded = true;

      if (this.$route.query.profile_id_callback) {//redirect alumni profile
        this.$router
          .push({
            path: "/alumni/formprofile?id=" + this.$route.query.profile_id_callback,
          })
          .catch((err) => { });
      } else {
        this.$router
          .push({
            path: "/engagement/",
          })
          .catch((err) => { });
      }


      // this.formData = Object.assign({}, form);
      // this.textParticipants = [];
      // this.tableData = [];
      // this.visible = false;
      // this.btnLoaded = true;
      // this.visible = false;
    },
  },
};
</script>